import { type AxiosError } from 'axios'
import { type IntlShape } from 'react-intl'

import { type Authentication400 } from '@redteclab/api/clients/bully'

import {
  ERR_DOB_TOO_YOUNG,
  ERR_EMAIL_INUSE,
  ERR_EMAIL_INVALID,
  ERR_EMAIL_MISSING_INVALID_FORMAT,
  ERR_FIRSTNAME_INVALID,
  ERR_LASTNAME_INVALID,
  ERR_PASSWORD_LENGTH_EXCEEDED,
  ERR_PASSWORD_TOOSHORT,
  ERR_SALUTATION_ERROR,
  ERR_TOS_NOT_ACCEPTED,
  MIN_AGE,
} from './consts'
import { MAX_PASSWORD_LENGTH } from './registrationFormValidation'

export const getRegistrationApiInvalidParamsErrorKeys = (
  error: AxiosError<Authentication400>,
): string[] => {
  if (error.response?.data.invalidParams) {
    return error.response.data.invalidParams
      .map((invalidParam) => invalidParam.key)
      .filter((key) => typeof key === 'string')
  }

  return []
}

export const getTranslationErrorMessagesForRegistration = (
  intl: IntlShape,
): Map<string, string> =>
  new Map([
    [
      ERR_DOB_TOO_YOUNG,
      intl.formatMessage(
        { id: 'login.createAccount.dateSelection.minAge' },
        { minAge: MIN_AGE },
      ),
    ],
    [ERR_EMAIL_INUSE, intl.formatMessage({ id: 'register.error.email.inUse' })],
    [
      ERR_EMAIL_INVALID,
      intl.formatMessage({ id: 'register.error.email.invalid' }),
    ],
    [
      ERR_EMAIL_MISSING_INVALID_FORMAT,
      intl.formatMessage({ id: 'register.error.email.invalid' }),
    ],
    [
      ERR_FIRSTNAME_INVALID,
      intl.formatMessage({ id: 'error.firstName.invalid' }),
    ],
    [
      ERR_LASTNAME_INVALID,
      intl.formatMessage({ id: 'error.lastName.invalid' }),
    ],
    [
      ERR_PASSWORD_LENGTH_EXCEEDED,
      intl.formatMessage(
        { id: 'form.error.input.maxLength' },
        { maxLength: MAX_PASSWORD_LENGTH },
      ),
    ],
    [
      ERR_PASSWORD_TOOSHORT,
      intl.formatMessage({ id: 'error.password.tooShort' }),
    ],
    [
      ERR_SALUTATION_ERROR,
      intl.formatMessage({ id: 'error.salutation.notChosen' }),
    ],
    [ERR_TOS_NOT_ACCEPTED, intl.formatMessage({ id: 'error.tos.notAccepted' })],
  ])
